<template>
    <AddressContainer name="Billing" :id="component.id" :passedAddress="renderStore.donor.billingAddress"
        :required="component.customData.required" :address1Label="component.customData.billingAddress1Label"
        :address1Placeholder="component.customData.billingAddress1Placeholder"
        :address2Placeholder="component.customData.billingAddress2Placeholder"
        :cityPlaceholder="component.customData.billingCityPlaceholder"
        :statePlaceholder="component.customData.billingStatePlaceholder"
        :postalPlaceholder="component.customData.billingPostalPlaceholder"
        :countryPlaceholder="component.customData.billingCountryPlaceholder" @update-address="updateBillingAddress"
        :is-shipping="false" />

    <div v-if="component.customData.enableShippingAddress" class="form-element-wrapper rd-relative"
        :class="isModalDisplay ? 'rd-mt-2.5' : 'rd-mt-4'">
        <input type="checkbox" id="shippingAddressChecked" class="rd-relative" v-model="shippingAddressChecked"
            @change="checkShippingAddress">

        <label for="shippingAddressChecked" class="rd-text-xs rd-mb-0 rd-ml-2.5">Provide separate shipping
            address</label>
    </div>

    <AddressContainer v-if="shippingAddressChecked" :class="isModalDisplay ? 'rd-mt-2.5' : 'rd-mt-4'" name="Shipping"
        :id="component.id" :passedAddress="renderStore.donor.shippingAddress" :required="false"
        :address1Label="component.customData.shippingAddress1Label"
        :address1Placeholder="component.customData.shippingAddress1Placeholder"
        :address2Placeholder="component.customData.shippingAddress2Placeholder"
        :cityPlaceholder="component.customData.shippingCityPlaceholder"
        :statePlaceholder="component.customData.shippingStatePlaceholder"
        :postalPlaceholder="component.customData.shippingPostalPlaceholder"
        :countryPlaceholder="component.customData.shippingCountryPlaceholder" @update-address="updateShippingAddress"
        :is-shipping="true" />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useRenderStore } from "@/builder/stores/renderStore";
import { PartialDisplayType } from "@/builder/enums";
import AddressContainer from "@/builder/components/input/AddressContainer.vue";

export default defineComponent({
    name: "AddressInputComponent",
    components: {
        AddressContainer,
    },
    props: {
        component: {
            type: Object,
            required: true,
        },
    },
    setup() {
        const renderStore = useRenderStore();
        return { renderStore };
    },
    data() {
        return {
            shippingAddressChecked: false,
        }
    },
    computed: {
        isModalDisplay() {
            return this.renderStore.page.partialDisplayType === PartialDisplayType.Modal;
        }
    },
    methods: {
        updateBillingAddress(address: any) {
            this.renderStore.donor.billingAddress = address;
        },

        updateShippingAddress(address: any) {
            this.renderStore.donor.shippingAddress = address;
        },

        checkShippingAddress() {
            if (this.renderStore.donor.shippingAddress) {
                this.renderStore.donor.shippingAddress = null;
            }
        },
    },
});
</script>
